module.exports = __webpack_public_path__ + "assets/img/yitianxie Info.dc1a3caa.png";